import { render } from "./ChatInput.vue?vue&type=template&id=62549b7a&scoped=true"
import script from "./ChatInput.vue?vue&type=script&lang=js"
export * from "./ChatInput.vue?vue&type=script&lang=js"

import "./ChatInput.vue?vue&type=style&index=0&id=62549b7a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62549b7a"]])

export default __exports__